module.exports = __webpack_public_path__ + "img/guanyu_quxiao@2x.c7a249f1.png";